export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Čeština'
  },
  'title': 'STAŽENÍ VÝROBKU  LEZECKÁ EXPRESKA ALPINISM / VERTIKA Z PRODEJE',
  'homepage': {
    'notice': 'Stažení produktu z trhu. Důležité informace týkající se vaší bezpečnosti a vybavení.',
    'purchaseWindow': 'Zakoupili jste si lezeckou expresku ALPINISM a/nebo VERTIKA mezi 1. lednem 2022 a 23. červencem 2026.',
    'skus': 'Expreska Alpinism 11 cm (4051175 / 8589547)\nExpreska Alpinism 17 cm (4051176 / 8589548)\nSadu 5 expresek Alpinism (4171656 / 8608405)\nExpreska Vertika 11 cm (5499689 / 8935765)\nExpreska Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Navrhování osobních ochranných prostředků s sebou nese absolutní odpovědnost vůči těm, kteří naše produkty používají. Proto vás informujeme o stažení expresky vybavené karabinou Rocky Fil z trhu.',
    'defect': 'U některých karabin jsme zjistili vadu v nýtování drátěné pojistky. Tato montážní vada může způsobit zlomení drátěné pojistky a vytvořit riziko zlomení karabiny v případě pádu.',
    'stopUsing': 'Z preventivních důvodů vás žádáme, abyste okamžitě přestali výrobek používat a postupovali podle níže uvedeného postupu.'
  },
  'procedure': {
    'stopUsing': '"Žádáme vás proto, abyste okamžitě přestali používat toto vybavení a zkontrolovali, zda se tato vada netýká i vašeho výrobku, a to pomocí níže uvedených pokynů pro řešení problémů.',
    'title': 'Jak zkontrolovat váš výrobek:',
    'intro': 'Zkontrolujte, zda obě strany drátěné pojistky zůstávají bezpečně připevněny ke karabině:',
    'step1': 'Uchopte karabinu na jedné straně, vložte palec mezi dva dráty (palcem nejblíže k nýtu). Pevně ​​zatlačte dolů na karabinu.',
    'step2': 'Otočte karabinu a opakujte stejný postup na druhé straně drátěné pojistky.'
  },
  'outcome': {
    'nok': {
      'body': 'Po kontrole se drát uvolnil: Prosíme, okamžitě přestaňte výrobek používat a vraťte jej do nejbližší prodejny DECATHLON. Náš tým se o váš vadný výrobek postará a neprodleně vám vrátí peníze za stažené zboží v plné výši.',
      'support': 'Pokud narazíte na jakékoli problémy, náš zákaznický servis je vám k dispozici, aby pro vás našel řešení na míru a provedl vás celým procesem: +420 228 800 008 od pondělí do pátku od 9:00 do 17:30.\n.'
    },
    'ok': {
      'body': 'Po kontrole se drát nevytahuje z pouzdra: Váš výrobek není touto vadou ovlivněn, můžete jej nadále používat s naprostým klidem.'
    }
  },
  'buttons': {
    'ok': 'Můj produkt je v pořádku',
    'nok': 'Můj produkt je v NOK'
  }
} as const
